import React from "react";
import { useLocalizedStrings } from "../../../Localization";
import { RichTextEditorWithToggle } from "@aidkitorg/typesheets/lib/richtexteditor";
import { EXPLANATION_CENTER_ALIGNMENT_CLASSES } from "./DashboardComponents/ExplanationContent";

export type ExplanationFormFieldsProps = {
  content: string;
  setContent: (val: string) => void;

  alignment: 'left' | 'center';
  setAlignment: (val: 'left' | 'center') => void;
};

export const ExplanationFormFields: React.FC<ExplanationFormFieldsProps> = ({
  content,
  setContent,
  alignment,
  setAlignment,
}) => {
  const L = useLocalizedStrings();

  return (
    <>
      <div>
        <label className="block text-sm font-medium mb-1">{L.admin_panel.dashboards.explanation_content}</label>
        <RichTextEditorWithToggle
          value={content}
          onChange={setContent}
          contentClassName={`flex flex-col justify-center ${alignment === 'center' ? EXPLANATION_CENTER_ALIGNMENT_CLASSES : ''}`}
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">{L.admin_panel.dashboards.explanation_alignment}</label>
        <select
          className="w-full border rounded-md p-2 text-sm"
          value={alignment}
          onChange={(e) => setAlignment(e.target.value as 'left' | 'center')}
        >
          <option value="center">Center</option>
          <option value="left">Left</option>
        </select>
      </div>
    </>
  );
};
